import http from "../../utils/http"

/**
 * 获取分页列表
 */
export function supplyPage(params) {
    return http({
        url: "/api/supply/page",
        data: params
    })
}
/**
 * 获取详情
 */
export function supplyDetail(params) {
    return http({
        url: "/api/supply/info",
        data: params
    })
}
/**
 * 获取列表
 */
 export function supplyList(params) {
    return http({
        url: "/api/supply/list",
        data: params
    })
}
/**
 * 我的供应
 */
 export function mySupply(params) {
    return http({
        url: "/api/supply/myPage",
        data: params
    })
}
/**
 * 上下架供应
 */
 export function editIsshow(params) {
    return http({
        url: "/api/supply/editIsshow",
        data: params
    })
}

/**
 * 添加
 */
 export function addsupply(params) {
    return http({
        url: "/api/supply/add",
        data: params
    })
}

/**
 * 编辑
 */
 export function editsupply(params) {
    return http({
        url: "/api/supply/edit",
        data: params
    })
}
